import { TableHeadersType } from '../tableHeadersType';

export const UNITS_MEASURMENT_HEADER: TableHeadersType[] = [
  {
    "label": "Stock Unit No.",
    "value": "stock_unit_id",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Stock Unit Name",
    "value": "stock_unit_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Stock Unit Symbol",
    "value": "stock_unit_symbol",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ADDED/MODIFIED BY",
    "value": "updated_by",
    "defaultChecked": true,
    "checked": true
  },
]